// RelatorioProdutos.js
import React, { useState, useEffect, useRef } from 'react';
import Chart from 'chart.js/auto'; // Importa Chart.js com auto-registro
import './RelatorioProdutos.css'; // Estilos CSS (mantidos iguais)

const RelatorioProdutos = () => {
  const [dataInicio, setDataInicio] = useState('2024-01-01');
  const [dataFim, setDataFim] = useState('2024-12-31');
  
  // Dados fictícios
  const [produtosData, setProdutosData] = useState([
    { Descricao: "Camiseta Básica", ReceitaGerada: 5000 },
    { Descricao: "Calça Jeans", ReceitaGerada: 3200 },
    { Descricao: "Tênis Esportivo", ReceitaGerada: 2800 },
    { Descricao: "Jaqueta de Couro", ReceitaGerada: 2500 },
    { Descricao: "Mochila Escolar", ReceitaGerada: 2000 },
    { Descricao: "Boné Estilizado", ReceitaGerada: 1800 },
    { Descricao: "Cinto de Couro", ReceitaGerada: 1500 },
    { Descricao: "Relógio Analógico", ReceitaGerada: 1200 },
    { Descricao: "Óculos de Sol", ReceitaGerada: 1000 },
    { Descricao: "Carteira de Bolso", ReceitaGerada: 800 },
  ]);

  const [clientesData, setClientesData] = useState([
    { Nome: "João Silva", TotalCompras: 12000 },
    { Nome: "Maria Oliveira", TotalCompras: 8500 },
    { Nome: "Pedro Santos", TotalCompras: 6000 },
    { Nome: "Ana Costa", TotalCompras: 4500 },
    { Nome: "Lucas Almeida", TotalCompras: 3000 },
  ]);

  const [tendenciasData, setTendenciasData] = useState([
    { DiaSemana: "Monday", TotalVendido: 2000 },
    { DiaSemana: "Tuesday", TotalVendido: 2500 },
    { DiaSemana: "Wednesday", TotalVendido: 1800 },
    { DiaSemana: "Thursday", TotalVendido: 2200 },
    { DiaSemana: "Friday", TotalVendido: 3000 },
    { DiaSemana: "Saturday", TotalVendido: 3500 },
    { DiaSemana: "Sunday", TotalVendido: 1500 },
  ]);

  const produtosChartRef = useRef(null);
  const clientesChartRef = useRef(null);
  const tendenciasChartRef = useRef(null);

  // Configuração dos gráficos
  useEffect(() => {
    // Gráfico de Produtos Mais Vendidos (Barras)
    if (produtosChartRef.current) produtosChartRef.current.destroy();
    const produtosCtx = document.getElementById('produtosMaisVendidosChart').getContext('2d');
    produtosChartRef.current = new Chart(produtosCtx, {
      type: 'bar',
      data: {
        labels: produtosData.map(p => p.Descricao),
        datasets: [{
          label: 'Receita Gerada (R$)',
          data: produtosData.map(p => p.ReceitaGerada),
          backgroundColor: 'rgba(54, 162, 235, 0.7)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: { beginAtZero: true, title: { display: true, text: 'Receita (R$)' } },
          x: { title: { display: true, text: 'Produtos' } }
        },
        plugins: {
          legend: { display: true },
          title: { display: true, text: 'Top 10 Produtos Mais Vendidos' }
        }
      }
    });

    // Gráfico de Clientes Mais Valiosos (Pizza)
    if (clientesChartRef.current) clientesChartRef.current.destroy();
    const clientesCtx = document.getElementById('clientesValiososChart').getContext('2d');
    clientesChartRef.current = new Chart(clientesCtx, {
      type: 'pie',
      data: {
        labels: clientesData.map(c => c.Nome),
        datasets: [{
          data: clientesData.map(c => c.TotalCompras),
          backgroundColor: [
            'rgba(255, 99, 132, 0.7)',
            'rgba(54, 162, 235, 0.7)',
            'rgba(255, 206, 86, 0.7)',
            'rgba(75, 192, 192, 0.7)',
            'rgba(153, 102, 255, 0.7)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { position: 'right' },
          title: { display: true, text: 'Top 5 Clientes Mais Valiosos' }
        }
      }
    });

    // Gráfico de Tendências de Vendas (Linha)
    if (tendenciasChartRef.current) tendenciasChartRef.current.destroy();
    const tendenciasCtx = document.getElementById('tendenciasVendasChart').getContext('2d');
    tendenciasChartRef.current = new Chart(tendenciasCtx, {
      type: 'line',
      data: {
        labels: tendenciasData.map(t => t.DiaSemana),
        datasets: [{
          label: 'Total Vendido (R$)',
          data: tendenciasData.map(t => t.TotalVendido),
          fill: false,
          borderColor: 'rgba(75, 192, 192, 1)',
          tension: 0.1
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: { beginAtZero: true, title: { display: true, text: 'Total Vendido (R$)' } },
          x: { title: { display: true, text: 'Dia da Semana' } }
        },
        plugins: {
          legend: { display: true },
          title: { display: true, text: 'Tendências de Vendas por Dia da Semana' }
        }
      }
    });

    // Limpeza ao desmontar o componente
    return () => {
      if (produtosChartRef.current) produtosChartRef.current.destroy();
      if (clientesChartRef.current) clientesChartRef.current.destroy();
      if (tendenciasChartRef.current) tendenciasChartRef.current.destroy();
    };
  }, [produtosData, clientesData, tendenciasData]);

  // Função para simular filtragem (atualiza dados fictícios com base nas datas)
  const handleFilter = () => {
    // Aqui você pode adicionar lógica para filtrar os dados fictícios com base em dataInicio e dataFim
    // Por simplicidade, apenas recarrega os mesmos dados
    setProdutosData([...produtosData]);
    setClientesData([...clientesData]);
    setTendenciasData([...tendenciasData]);
  };

  return (
    <div className="relatorio-produtos-container">
      <h1>Relatórios de Produtos</h1>
      <div className="filtros">
        <label>
          Data Início:
          <input
            type="date"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
          />
        </label>
        <label>
          Data Fim:
          <input
            type="date"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
          />
        </label>
        <button onClick={handleFilter}>Filtrar</button>
      </div>

      <div className="graficos">
        <div className="grafico-item">
          <canvas id="produtosMaisVendidosChart"></canvas>
        </div>
        <div className="grafico-item">
          <canvas id="clientesValiososChart"></canvas>
        </div>
        <div className="grafico-item">
          <canvas id="tendenciasVendasChart"></canvas>
        </div>
      </div>
    </div>
  );
};

export default RelatorioProdutos;